(() => {
  const ROOT_SELECTOR = '[data-quiz-banner]';
  const CHANGE_INTERVAL = 300;

  function initializeBanner(root) {
    if (!root || root.dataset.quizBannerInitialized === 'true') {
      return;
    }

    const slots = Array.from(root.querySelectorAll('[data-quiz-slot]'));

    if (slots.length !== 3) {
      return;
    }

    const validSlots = slots.every((slot) => {
      return slot.querySelectorAll('[data-quiz-pin]').length === 3;
    });

    if (!validSlots) {
      return;
    }

    root.dataset.quizBannerInitialized = 'true';

    let slotIndex = 0;

    window.setInterval(() => {
      if (
        document.hidden ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
        !root.classList.contains('swiper-slide-active')
      ) {
        return;
      }

      const slot = slots[slotIndex];
      const pins = Array.from(slot.querySelectorAll('[data-quiz-pin]'));
      const currentIndex = pins.findIndex((pin) => pin.classList.contains('is-active'));
      const nextIndex = (currentIndex + 1) % pins.length;

      pins.forEach((pin, index) => {
        pin.classList.toggle('is-active', index === nextIndex);
      });

      slotIndex = (slotIndex + 1) % slots.length;
    }, CHANGE_INTERVAL);
  }

  function initializeAll(scope = document) {
    if (scope.matches?.(ROOT_SELECTOR)) {
      initializeBanner(scope);
    }

    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(initializeBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAll(event.target);
  });
})();
